export enum TrackingEvent {
  OverflowMenuShowed = `Views overflow menu showed`,
}

export enum TrackingEventProperty {
  Source = `Source`, // example: report-header, signup-page, etc...
  NumberOfViews = `Number of views`,
  NumberOfRecentViewsLast30d = `Number of recent views (last 30d)`,
  ResourceType = `Resource type`,
  ResourceSubType = `Resource sub type`,
  ViewerType = `Viewer type`,
}

export type UserListTrackProperties = {
  [TrackingEventProperty.NumberOfViews]?: number;
  [TrackingEventProperty.ResourceType]?: `dashboard` | `report`;
  [TrackingEventProperty.ViewerType]?: `creator` | `viewer`;
};

export function track(event: TrackingEvent, properties: UserListTrackProperties) {
  mixpanel.track(event, properties);
}
